import React from "react";

const Hello = () => {
  return (
    <div>
      <h1>Hello Page</h1>
      <p>This is the Sri Lanka Adventure Tour details page.</p>
    </div>
  );
};

export default Hello;
